const UNKNOWN_VALUE = 'Unknown';

type GetJointAvatarDescriptionArgs = {
  item1?: string | null;
  item2?: string | null;
};

export const getJointAvatarDescription = ({ item1, item2 }: GetJointAvatarDescriptionArgs) => {
  if (!item1 && !item2) {
    return undefined;
  }

  if (item1 === UNKNOWN_VALUE && item2 === UNKNOWN_VALUE) {
    return undefined;
  }

  if (item1 === UNKNOWN_VALUE) {
    if (item2) {
      return item2;
    }

    return undefined;
  }

  if (item2 === UNKNOWN_VALUE) {
    if (item1) {
      return item1;
    }

    return undefined;
  }

  if (item1 && !item2) {
    return item1;
  }

  if (!item1 && item2) {
    return item2;
  }

  return `${item1} · ${item2}`;
};
